<template>
<div class='checkFileDialog__container' v-if='show'>
<transition name='fade'>
    <div class="blackmask" ></div>
</transition>
<transition>
    <div class="checkFileDialog__box" >
        <div class="checkFile__tip">
            <span>你所上传的{{filename}}已存在,请选择以下几种上传方式:</span>
        </div>
        <div class="checkFile__confirm">
        <button-pay-egis :text='"跳过"' @click.native="chooseType('skip')"></button-pay-egis>
        <button-pay-egis :text='"覆盖"' @click.native="chooseType('cover')"></button-pay-egis>
        <button-pay-egis :text='"保留"' @click.native="chooseType('both')"></button-pay-egis>
        </div>
    </div>
</transition>
</div>
</template>

<script>
import buttonPayEgis from '../common/button'
import eventBus from '../../../../../lib/eventBus'
export default {
    components:{
        buttonPayEgis,
    },
    methods:{
        chooseType(prop)
        {  
           eventBus.$emit('solveRepeatFile',prop,this.md5)
           this.show=false;
        }
    }
}
</script>

<style lang="scss" scoped>
.checkFileDialog__container{
    position: absolute;
    width:100%;
    height:100%;
    .blackmask{
        width:100%;
        height:100%;
        background-color: rgba(0,0,0,0.002);
        position: absolute;
        z-index:100;
        }
    .checkFileDialog__box{
        position: absolute;
        z-index:999;
        width:15rem;
        height:6rem;
        border:2px solid #d7d7d7;
        border-radius: 5px;
        background-color: #fff;
        left:0;
        right:0;
        bottom:0;
        top:-12rem;
        margin:auto;
        padding:1rem;
        .checkFile__tip{
        font-size: 0.8rem;
        color:#333;
        text-indent: 1rem;
        line-height: 1.5rem;
        }
        .checkFile__confirm{
        display: flex;
        justify-content: space-around;
        margin-top:1rem;
    }
    }
}

</style>